export default {
  objectives: [],
  objective: null,
  pagination: {},
  ods: [],
}
